module.exports = __webpack_public_path__ + "media/images/emblems/Muellheim-Blazono-73c9c98603b6a12af263b6cca417f87f.png";